var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGreenSk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-green-sk_svg__clip0_7021_35924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16v32.001c0 8.837 7.164 16 16 16h32c8.837 0 16.001-7.163 16.001-16v-48H16z",
    fill: "#B1EC52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.492 25.557c-.523-2.29 1.76-4.314 4.714-4.314 2.661 0 5.328.596 6.343 4.306h3.411v5.662c-4.253-3.496-13.472-1.303-14.468-5.654zm35.393-1.568H45.2l-7.31 8.006V16h-5.93v3.876a9.936 9.936 0 00-.627-.74c-2.157-2.284-5.264-3.441-9.237-3.441-4.594 0-7.207 2.056-8.59 3.78-1.716 2.142-2.483 5.064-1.952 7.445 1.374 6.165 7.094 7.15 11.296 7.695 3.318.432 6.491 1.034 6.407 3.991-.088 3.069-3.547 3.823-5.817 3.823-5.914 0-6.113-4.37-6.113-4.37h-6.36c.093 1.64.589 4.276 2.61 6.537 2.212 2.478 5.53 3.734 9.863 3.734 3.323 0 6.35-1.083 8.52-3.005v2.642h5.93v-7.55l2.099-2.296 5.99 9.846h6.903l-8.718-14.42 8.72-9.558",
    fill: "#424B52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-green-sk_svg__clip0_7021_35924"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
}
export default SvgLogoGreenSk;